module.exports = __webpack_public_path__ + "static/img/solu1.86ffba6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solu1.png
// module id = 94X+
// module chunks = 1